import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { wacToken } from "@/libraries/design/foundations";

import { messages } from "./messages";

const statusContainerStyles = css({
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
    marginBlockEnd: "16px"
});

const statusIconStyles = css({
    flexShrink: 0,
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "50%",
    fontSize: "12px",
    lineHeight: 1,
    color: wacToken("color.neutral.light0")
});

const statusTextStyles = css({
    fontFamily: wacToken("font.charlie.text"),
    fontSize: "14px",
    color: wacToken("color.primary.black"),
    lineHeight: "1.5"
});

interface StatusMessageProps {
    exceeds: boolean;
}

export const StatusMessage = ({ exceeds }: StatusMessageProps) => {
    const intl = useIntl();

    const iconBg = exceeds ? wacToken("color.secondary.red") : "#22A06B";
    const iconChar = exceeds ? "✕" : "✓";
    const statusText = exceeds
        ? intl.formatMessage(messages.exceeds)
        : intl.formatMessage(messages.atPar);

    return (
        <div css={statusContainerStyles}>
            <div
                css={statusIconStyles}
                // eslint-disable-next-line local/ensure-wac-token-usage
                style={{ backgroundColor: iconBg }}
                aria-hidden="true"
            >
                {iconChar}
            </div>
            <p css={statusTextStyles}>
                Your estimated usage is <strong>{statusText}</strong> with the
                units available in the total pool. Here is the breakdown:
            </p>
        </div>
    );
};
